import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE, PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
`;

export const LogoContainer = styled.div`
  margin-top: 40px;
`;

export const BackgroundGradient = styled.div`
  position: absolute;
  width: 1104px;
  height: 1104px;
  left: calc(50% - 1104px / 2);
  top: -1010px;

  background: linear-gradient(
    180deg,
    rgba(64, 117, 255, 0.08) 0%,
    rgba(20, 83, 245, 0.5) 100%
  );
  opacity: 0.4;
  filter: blur(200px);
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const Title = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 20px;
`;

export const SubTitle = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 14px;
  font-weight: 300;
  margin-bottom: 40px;
`;

export const SubTitleEmail = styled.div`
  background-color: ${BLUE_LIGHT};
  border-radius: 8px;
  color: ${OLD_BLUE};
  display: inline;
  padding: 0px 6px;
`;
